import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('tik-tok-filled-circle-icon');
export var TikTokFilledCircleIcon = function TikTokFilledCircleIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: cls.name(className),
    width: "16",
    height: "16",
    viewBox: "0 0 46 46"
  }, React.createElement("path", {
    d: "M23.2,0c-12.7,0-23,10.3-23,23s10.3,23,23,23s23-10.3,23-23S35.9,0,23.2,0z M33.8,20.9c-1.3,0-2.6-0.3-3.9-0.8\n\tc-0.8-0.3-1.5-0.8-2.2-1.3l0,8.8c0,2-0.8,3.8-2.2,5.2c-1.2,1.1-2.6,1.9-4.2,2.1C21,35,20.6,35,20.2,35c-1.7,0-3.3-0.5-4.6-1.6\n\tc-0.2-0.2-0.5-0.4-0.7-0.6c-1.5-1.5-2.3-3.6-2.2-5.7c0.1-1.6,0.8-3.2,1.9-4.4c1.4-1.6,3.5-2.5,5.6-2.5c0.4,0,0.8,0,1.1,0.1v4\n\tC21,24.1,20.6,24,20.2,24c-2,0-3.6,1.6-3.5,3.6c0,1.3,0.7,2.4,1.7,3c0.5,0.3,1,0.5,1.6,0.5c0.5,0,0.9,0,1.3-0.2\n\tc1.4-0.5,2.4-1.8,2.4-3.4V11h3.9c0,0.4,0,0.8,0.1,1.1c0.3,1.5,1.1,2.8,2.3,3.6c1,0.8,2.3,1.2,3.6,1.2c0,0,0,0,0,0V20.9z"
  }));
};